import dashboardVersion from "../version.json"
import type { RuntimeVersion } from "./dashboard-types"

export const dashboardRuntimeVersion: RuntimeVersion = {
  component: dashboardVersion.component,
  version: dashboardVersion.version,
  major: Number(dashboardVersion.version.split(".")[0]),
  reportsAs: dashboardVersion.reportsAs,
  compatibility: dashboardVersion.compatibility ?? {},
  build: {
    builtAt: null,
    commit: null,
    dirty: null
  }
}
